import { Shark } from "shark-mvc";
import NousCoreModel from "./NousCoreModel";

class ApplicatorTeam extends NousCoreModel {
	calendarURL = "";
	description = "";
	extraData = {
		enabled: false
	};
	name = "";
	subCalendarId = "";
	
	__enabledLabel = "No";

	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = super.export();

		exportData.extraData = this.exportObjectField("extraData");

		return exportData;
	}
	
	import (data, options) {
		super.import(data, options);

		this.parseEnabled();
	}

	onExtraData_enabledChanged () {
		this.parseEnabled();
	}

	parseEnabled () {
		if (typeof this.extraData.enabled !== "undefined") {
			this.__enabledLabel = this.extraData.enabled ? "Sì" : "No";
		}
	}
}

Shark.registerModel("ApplicatorTeam", ApplicatorTeam);

export default ApplicatorTeam;
